$( document ).ready(function() {
	var adds_on_popup = $('[data-zg-role="adds_on_popup"]');
	var delay =adds_on_popup.data('delay');
	if( adds_on_popup.length ){
		setTimeout(() => {
			adds_on_popup.modal('show');
		}, delay );
		
	}
});	